<template>
    <div class="headerBox">
        <div class="logo">
            <img v-if="activeIndex === '2'" style="height: 100%;width: 100%;" src="https://distributionback.myweixue.com/distribution/202509/bg-block.png"
                alt="">
            <img v-else style="height: 100%;width: 100%;" src="https://distributionback.myweixue.com/newWebsite/logo.png"
                alt="">
                <!-- https://wx-distribution.oss-cn-hangzhou.aliyuncs.com/distribution/202509/bg-block.png?x-oss-credential=LTAI5t9Tbfgjv999LENHXUqa%2F20250911%2Fcn-hangzhou%2Foss%2Faliyun_v4_request&x-oss-date=20250911T082631Z&x-oss-expires=3600&x-oss-signature-version=OSS4-HMAC-SHA256&x-oss-signature=275ea70f70f092211cf736383aff2de6b7300f3877f1995ff082d073999eadb7 -->
        </div>
        <div class="headerNav">
            <div v-for="(item, index) in headerNav" :key="item.path"
                :class="['headerNavItem', activeIndex === '2' ? 'headerNavItemBlock' : '', { 'active': activeIndex == index && activeIndex !== '2' }, { 'active-block': activeIndex == index && activeIndex === '2' }]" @click="changeTab(item, index)">{{
                    item.title }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['activeIndex'],

    data() {
        return {
            headerNav: [
                { title: '人文思辨课', path: '/' },
                { title: '圆桌数理课', path: '/siliconValley' },
                { title: '我们的故事', path: '/weStory' },
                // { title: '少年CEO', path: '/youngPerson' },
                { title: '企业文化', path: '/culture' },
                { title: '加入我们', path: '/added' },
                { title: '客户端下载', path: '/classView' }
            ],
            isShow: false,
        }
    },
    methods: {
        changeTab(item, index) {
            // 检查是否是“加入我们”项

            if (this.$route.path !== item.path) {
                this.$router.push(item.path);

            }
        }
    }
}
</script>

<style scoped lang="scss">
* {
    padding: 0;
    margin: 0;
}

.headerBox {
    box-sizing: border-box;
    padding: 0 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 60px;
}

.logo {
    height: 60px;
    width: 128px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.headerNav {
    height: 100%;
    width: 729px;
    display: flex;
    white-space: nowrap;
    justify-content: space-between;

}

.headerNavItem {
    line-height: 60px;
    height: 100%;
    color: #fff;
    font-family: 'JjySmall';
    cursor: pointer;
    font-size: 16px;
}
.headerNavItemBlock {
    color: #000;
}



.hidden_download_btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 130px;
    height: 85px;
    // background-color: red;
}



.active {
    // color: #fff;
    font-family: 'JjyHeave';
    font-weight: bold;
}

.active::after {
    content: '';
    display: block;
    border-radius: 3px;
    margin: 0 auto;
    height: 4px;
    width: 50%;
    background: rgb(255, 255, 255);
    margin-top: -10px;
}
.active-block {
    // color: #fff;
    font-family: 'JjyHeave';
    font-weight: bold;
}

.active-block::after {
    content: '';
    display: block;
    border-radius: 3px;
    margin: 0 auto;
    height: 4px;
    width: 50%;
    background: #000;
    margin-top: -10px;
}

.el-dialog__wrapper {
    span {
        font-size: 30px;
    }
}

::v-deep .el-button {
    padding: 10px 20px;

    span {
        font-size: 25px;
    }
}

::v-deep .el-dialog__title {
    font-size: 30px;
}
</style>
